(function($) {

	$('.search-icon').click(function(e) {
		e.stopPropagation();
		$('.search-popup').addClass('active');
	});

	$('.search-close').click(function(e) {
		e.stopPropagation();
		$('.search-popup').removeClass('active');
	});

})(jQuery);
